module.exports = __webpack_public_path__ + "img/practice.7a2acd2a.png";